import Breadcrumb from 'shopper/components/Breadcrumb/V1/Breadcrumb';
import Heading from 'shopper/components/Heading';

import BreadcrumbItem from 'components/Breadcrumb/Item';

import placeholder from 'lib/placeholder';

import LINKS from 'constants/links';

const BREADCRUMB_FIRST_ITEM = 'Home';

const MyOffersHeading = (props) => (
  <div {...props}>
    <Breadcrumb>
      <BreadcrumbItem href={LINKS.HOME}>{BREADCRUMB_FIRST_ITEM}</BreadcrumbItem>
      <BreadcrumbItem>{placeholder('breadcrumbs.myOffers')}</BreadcrumbItem>
    </Breadcrumb>
    <Heading as="h1" className="mb-2" size="size2">
      {placeholder('titles.myOffers')}
    </Heading>
  </div>
);

export default MyOffersHeading;
